import { truncateTitle } from 'utils/gate';
import { useLinearGradient, useRadialGradient } from '../Gradients/useGradient';
import useFigure from '../useFigure';
import { strokeWidth, gateFontSize } from '../constants';
import getGateDesignByName from '../Gradients/getGateDesignByName';

const Gate = ({
  name, qubits, controls,
}) => {
  const {
    x, y,
  } = qubits.rect.center;

  const {
    x: x1, y: y1, width, height,
  } = qubits.rect;

  const { grd: gradient, icon, shape } = getGateDesignByName(name);
  const { startColor: firstColor, endColor: lastColor } = gradient.stroke;
  const { startColor, endColor, scale } = gradient.fill;

  const stroke = useLinearGradient({
    x1, y1, x2: x1 + width, y2: y1 + height, firstColor, lastColor,
  });
  const grd = useRadialGradient({
    startColor, endColor, width, scale, x: x1, y: y1,
  });

  const Circle = useFigure('circle');
  const Line = useFigure('line');
  const Text = useFigure('text');
  const Rect = useFigure('roundRect');
  const Cross = useFigure('cross');
  const firstControl = controls[0];
  // draw controls
  if (controls.length) {
    Line({
      x1: x, y1: y, x2: firstControl.x, y2: firstControl.y, stroke, strokeWidth,
    });
    controls.forEach((control) => {
      Circle({
        cx: control.x, cy: control.y, r: width / 10, fill: stroke, strokeWidth,
      });
    });
  }
  const [title, restText] = name.split('(');
  const truncatedTitle = truncateTitle(title, width, gateFontSize, shape);
  const subTitle = restText ? `(${restText}` : '';
  const textBaseline = subTitle ? 'bottom' : 'middle';
  const backGround = 'rgba(6, 14, 31, 1)';

  // console.log(name, s, subTitle, shape);
  switch (shape) {
    case 'rect':
      Rect({
        ...qubits.rect, fill: grd, stroke, strokeWidth, radii: [4], backGround,
      });
      break;
    case 'dot':
      controls.forEach(() => {
        Circle({
          cx: x, cy: y, r: width / 10, fill: stroke, strokeWidth,
        });
      });
      break;
    default:
      Circle({
        cx: x, cy: y, r: width / 2, fill: grd, stroke, backGround, strokeWidth,
      });
  }

  // Text for title
  switch (icon) {
    case 'text':
      Text({
        text: truncatedTitle,
        x,
        y,
        fill: '#F2F5FA',
        textBaseline,
        textAlign: 'center',
        font: `${gateFontSize}px Satoshi`,
      });
      break;
    case 'none':
      break;
    default:
      Cross({
        cx: x, cy: y, r: width * 0.25, stroke: 'white', strokeWidth,
      });
  }
};

export default Gate;
